import { initializeClientSentry } from "./lib/monitoring/sentry"

void initializeClientSentry()
